export const TimeUnits = {
	m: 'minutes',
	h: 'hours',
	d: 'days',
	w: 'weeks',
} as const;

// DateTime Types
export const WithinTheLast = 'within_the_last' as const;
export const MoreThan = 'more_than' as const;
export const Between = 'between' as const;
export const InRange = 'in_range' as const;
export const NowOverdue = 'now_overdue' as const;
export const DueInNext = 'due_in_next' as const;
export const BetweenDateTime = 'between_date_time' as const;

// DateTime Component types
export const BetweenComponent = 'between' as const;
export const BetweenDateTimeComponent = 'between_date_time' as const;
export const InRangeComponent = 'in_range' as const;
export const TimeInputComponent = 'time_input' as const;
export const IsNotSetComponent = 'is_not_set' as const;

export const DateTimeVariations: {
	DueDate: 'DueDate';
	DateTime: 'DateTime';
	DateTimeRange: 'DateTimeRange';
} = {
	DueDate: 'DueDate',
	DateTime: 'DateTime',
	DateTimeRange: 'DateTimeRange',
};
